import React from 'react'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import { Dialog } from 'primereact/dialog'
import './DialogHistoryChange.scss'
import HistoryChange from '../../HistoryChange/HistoryChange'

const DialogHistoryChange = (props: {
    dialogVisible: boolean
    changeFields: any[]
    onHide: () => void
    timezone: string
}) => {
    const { dialogVisible, onHide, changeFields, timezone } = props

    const componentClass = 'smart-modals-dialog-history-change'

    const intl = useIntl()

    return (
        <Dialog
            header={intl.formatMessage({
                id: `modals.new.activity.creation.cta.history.change`,
                defaultMessage: 'History change',
            })}
            draggable={false}
            visible={dialogVisible}
            onHide={() => onHide()}
            style={{ width: '50vw' }}
            maskClassName={componentClass}
            breakpoints={{ '960px': '85vw' }}>
            <HistoryChange changeFields={changeFields} timezone={timezone} />
        </Dialog>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(DialogHistoryChange)
